import { stepControlsContextObj } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSendFeedbackSucceed } from '../../selectors/sendFeedback';
import { useApplicationContext } from '../../containers/ApplicationContext';
import { EEventType } from '../../types/eventEmitter';
import { ESpecialViews } from '../../types/view';
export function useStepsEvents() {
  var _useApplicationContex = useApplicationContext(),
    emitter = _useApplicationContex.emitter;
  var isSendFeedbackSucceed = useSelector(selectSendFeedbackSucceed);
  var _React$useContext = React.useContext(stepControlsContextObj),
    currentStep = _React$useContext.currentStep;
  var currentStepCode = currentStep.code;
  React.useEffect(function () {
    var trackViewChange = function trackViewChange() {
      if (isSendFeedbackSucceed) {
        // Это событие вызовется, поскольку после успешной отправки формы,
        // currentStepCode сбрасывается в самое начальное состояние
        emitter.emit(EEventType.ViewChanged, {
          view: ESpecialViews.MessageSent
        });
      } else {
        emitter.emit(EEventType.ViewChanged, {
          view: currentStepCode
        });
      }
    };

    // Можно установить таймаут и 0 мс, но на всякий случай оставлю 50, это ничего не изменит
    var timeoutId = setTimeout(trackViewChange, 50);
    return function () {
      return clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepCode]);
}